import AnalysysAgent from 'ans-javascript-sdk/sdk/AnalysysAgent_JS_SDK.es6.min.js'
import {env} from './environment'
import Vue from 'vue'
const AnalysysAgentConfig = {
  publish: {
    debugMode: 0,
    appkey: 'f9705b372930d61f', //APPKEY
    uploadURL: 'https://frp-log.yaomaitong.cn' //上传数据的地址
  },
  pre: {
    debugMode: 0,
    appkey: 'f9705b372930d61f', //APPKEY
    uploadURL: 'https://frp-log.yaomaitong.cn' //上传数据的地址
  },
  dev: {
		//本地开发先关掉debug模式 2开启 0关闭
    debugMode: window.location.host.indexOf('yaomaitong') > -1 ? 2 : 0,
    encryptType: 0,
    appkey: '43f814dd272484a1', //APPKEY
    uploadURL: 'https://log.yaomaitong.net' //上传数据的地址
  }
}
export function initAnalysysAgent() {
    // 避免页面阻塞
    try {
      // 只在线上环境初始化埋点 SDK
      if (env() !== 'publish') {
        console.log('[Analytics] 非线上环境跳过埋点初始化，当前环境:', env())
        // 创建空方法避免调用报错
        window.$analysysAgentTrack = () => {}
        Vue.prototype.$analysysAgentTrack = () => {}
        window.$analysysAgentSetProfile = () => {}
        Vue.prototype.$analysysAgentSetProfile = () => {}
        Vue.prototype.$analysysAgentSetAlias = () => {}
        return
      }

      AnalysysAgent.init(AnalysysAgentConfig[env()])
      window.$analysysAgentTrack = (name, opt) => {
        AnalysysAgent.track(name, opt)
      }
      Vue.prototype.$analysysAgentTrack = (name, opt) => {
        AnalysysAgent.track(name, opt)
      }
      window.$analysysAgentSetProfile = (info) => {
        AnalysysAgent.profileSet(info)
      }
      Vue.prototype.$analysysAgentSetProfile = (info) => {
        AnalysysAgent.profileSet(info)
      }
      Vue.prototype.$analysysAgentSetAlias = (code) => {
        AnalysysAgent.alias(code)
      }
    } catch (e) {
      console.log(e)
    }
}
